
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12.5","cy":"12.5","r":"12.5","fill":"#E9E5FF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 12.5v-4A1.5 1.5 0 017.5 7h7.004A1.5 1.5 0 0116 8.385h-1.01A.5.5 0 0014.505 8H7.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h3.501v1.572c-.552 0-1 .504-1 1.125 0 .105.013.207.037.303H9.002a.5.5 0 110-1h.5v-1H7.5A1.5 1.5 0 016 12.5z","fill":"#BDB0FF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.945 15.6a.81.81 0 00.735.466h5.976c.266 0 .519-.11.698-.303l.15-.163h-7.559zm7.56-.932c.374 0 .713.218.864.557a.923.923 0 01-.167 1.005l-.15.163a1.902 1.902 0 01-1.396.606h-5.975a1.756 1.756 0 01-1.583-.985.918.918 0 01-.098-.413c0-.516.423-.933.945-.933v-3.73c0-.773.635-1.399 1.417-1.399h4.725c.783 0 1.418.626 1.418 1.399v3.73zm-6.615 0h5.67v-3.73a.47.47 0 00-.473-.466h-4.725a.47.47 0 00-.472.466v3.73z","fill":"#BDB0FF"}})])
          )
        }
      }
    